import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import es from '@angular/common/locales/es';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor(private primengConfig: PrimeNGConfig, private http: HttpClient) {
        this.translatePrimeNg();
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;
        Chart.register(ChartDataLabels);

    }

    async translatePrimeNg(): Promise<void> {
        registerLocaleData( es );
        const resp: any = await lastValueFrom(this.http.get('assets/language_es.json', {headers: {}}));
        this.primengConfig.setTranslation(resp.primeng);
    }

}
